import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useServices = () =>
  useQuery({
    queryKey: ["services"],
    queryFn: async () => (await api.get("/services")).data,
    staleTime: Infinity,
  });
